import { render, staticRenderFns } from "./AgreeCheckBox.vue?vue&type=template&id=6029cb60"
import script from "./AgreeCheckBox.vue?vue&type=script&lang=js"
export * from "./AgreeCheckBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports